// @flow

import React from 'react';
import styled from 'styled-components';
import BaseComponent from '../lib/base-component';
import BasicButton from '../components/basic-button';
import { SectionChild } from '../components/section';

type Props = {
  label: string,
  onClick: Function,
  _parent: string
};

const WrappedButton = styled(BasicButton)`
  padding: 0;
`;

export default class Button extends BaseComponent<Props> {
  static _type = 'Button';
  _type = 'Button';

  render() {
    const { label, onClick } = this.props;

    return (
      <SectionChild>
        <WrappedButton onClick={onClick}>
          {label}
        </WrappedButton>
      </SectionChild>
    );
  }
}



// WEBPACK FOOTER //
// ./src/fitbit-components/button.js